import { Button } from "@coval/ui"

import {
  CreateResourceButton,
  SaveResourceButton,
} from "@/components/ResourceActionButton"

interface TestSetHeaderActionsProps {
  hasChanges: boolean
  hasPending: boolean
  isNewTestSet: boolean
  isSaving: boolean
  isUnsavedNew: boolean
  onCancel: () => void
  onDiscard: () => void
  onSave: () => void
  testCaseCount: number
}

function SaveButton(input: {
  action: "create" | "save"
  disabled: boolean
  loading: boolean
  onSave: () => void
  tooltip: string | null
}) {
  const sharedProps = {
    resourceName: "Test Set",
    validationIssues: input.tooltip ? [input.tooltip] : undefined,
    onClick: input.onSave,
    disabled: input.disabled,
    loading: input.loading,
    className: "text-sm",
    "data-testid": "test-set-editor-save-button",
  }

  return input.action === "create" ? (
    <CreateResourceButton {...sharedProps} />
  ) : (
    <SaveResourceButton {...sharedProps} />
  )
}

export function TestSetHeaderActions({
  hasChanges,
  hasPending,
  isNewTestSet,
  isSaving,
  isUnsavedNew,
  onCancel,
  onDiscard,
  onSave,
  testCaseCount,
}: TestSetHeaderActionsProps) {
  if (isNewTestSet || isUnsavedNew) {
    const isEmpty = testCaseCount === 0 && !hasPending

    return (
      <div className="flex items-center gap-2 shrink-0">
        <Button variant="ghost" onClick={onDiscard} className="text-sm">
          Discard
        </Button>
        <SaveButton
          action={isUnsavedNew ? "create" : "save"}
          disabled={isSaving}
          loading={isSaving}
          onSave={onSave}
          tooltip={isEmpty ? "Add at least one test case" : null}
        />
      </div>
    )
  }

  if (!hasChanges && !hasPending) {
    return null
  }

  const isEmpty = testCaseCount === 0 && !hasPending
  return (
    <div className="flex items-center gap-2 shrink-0">
      <Button variant="ghost" onClick={onCancel} className="text-sm">
        Cancel
      </Button>
      <SaveButton
        action="save"
        disabled={isSaving}
        loading={isSaving}
        onSave={onSave}
        tooltip={isEmpty ? "Add at least one test case" : null}
      />
    </div>
  )
}
